import { sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function pacotes (dados) {
  let created = ''
  if (dados) {
    if (dados.data_inicial && dados.data_final) {
      created = '&createdAt=' + dados.data_inicial + '&createdAt=' + dados.data_final
    } else if (dados.data_inicial && !dados.data_final) {
      created = '&createdAt=' + dados.data_inicial + '&createdAt='
    } else if (!dados.data_inicial && dados.data_final) {
      created = '&createdAt=&createdAt=' + dados.data_final
    }
  }
  let dadosserial = serialize(dados) + created
  return sessaoFetchLoading(`base`, `/api/fornecedor/pacote?` + dadosserial, 'GET')
}
export async function fornecedores () {
  return sessaoFetchLoading(`base`, `/api/fornecedor`)
}
export async function fornecedoresSelect () {
  return sessaoFetchLoading(`base`, `/api/fornecedor?all=1`)
}
export async function addPacote (dados) {
  return sessaoFetchLoading(`base`, `/api/fornecedor/pacote`, 'POST', dados)
}
export async function inativaPacote (id) {
  return sessaoFetchLoading(`base`, `/api/fornecedor/pacote/${id}/inativar`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/fornecedor.js